export interface FogLayerProps {
  opacity?: number;
}

const FOG_BANDS = [
  { top: "12%", dur: "38s", delay: "0s", blur: 14, height: 26, op: 0.18 },
  { top: "28%", dur: "52s", delay: "-12s", blur: 22, height: 40, op: 0.1 },
  { top: "46%", dur: "44s", delay: "-22s", blur: 18, height: 34, op: 0.14 },
  { top: "64%", dur: "60s", delay: "-8s", blur: 26, height: 50, op: 0.08 },
  { top: "82%", dur: "48s", delay: "-30s", blur: 16, height: 30, op: 0.12 },
];

export function FogLayer({ opacity = 1 }: FogLayerProps) {
  return (
    <div
      style={{
        position: "absolute",
        inset: 0,
        pointerEvents: "none",
        overflow: "hidden",
        opacity,
        zIndex: 0,
      }}
    >
      {FOG_BANDS.map((b, i) => (
        <div
          key={i}
          style={{
            position: "absolute",
            left: "-30%",
            width: "160%",
            top: b.top,
            height: b.height,
            background: `linear-gradient(90deg, transparent, rgba(14,14,14,${b.op}) 30%, rgba(14,14,14,${b.op * 0.8}) 60%, transparent)`,
            filter: `blur(${b.blur}px)`,
            animation: `fog-drift ${b.dur} linear ${b.delay} infinite`,
          }}
        />
      ))}
    </div>
  );
}
